import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PowerGenerationConsumptionForm from '../Forms/PowerGenerationConsumptionForm';

const AddEditPowerGenerationConsumptionModal = ({
	establishment_id,
	dataPowerGenerationConsumption,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Registrar'} Consumo
			</ModalHeader>

			<PowerGenerationConsumptionForm
				establishment_id={establishment_id}
				dataPowerGenerationConsumption={dataPowerGenerationConsumption}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditPowerGenerationConsumptionModal;
